module.exports = function() {
  return new Worker(__webpack_public_path__ + "46ecd76f9dfa3ca8e744.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/worker/source.worker.js
// module id = 192
// module chunks = 0